import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GavelIcon from '@mui/icons-material/Gavel';
import PersonIcon from '@mui/icons-material/Person';
import HandshakeIcon from '@mui/icons-material/Handshake';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SettingsIcon from '@mui/icons-material/Settings';
import EmailIcon from '@mui/icons-material/Email';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const Regolamento = () => {
  return (
    <div className="mx-auto mt-8 w-full max-w-3xl">
      <div className="card overflow-hidden">
        <div className="bg-gradient-to-br from-slate-900/5 via-emerald-600/5 to-white">
          <div className="card-body">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <Link to="/dashboard" className="btn-outline">
                <ArrowBackIcon fontSize="small" />
                Dashboard
              </Link>
              <div className="flex flex-wrap gap-2">
                <span className="badge">
                  <GavelIcon fontSize="small" />
                  Regole
                </span>
                <span className="badge">
                  <HandshakeIcon fontSize="small" />
                  Reciprocità
                </span>
                <span className="badge">
                  <AccountBalanceWalletIcon fontSize="small" />
                  Saldo minimo: -3h
                </span>
              </div>
            </div>

            <div className="mt-4">
              <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">Regolamento Utente</h1>
              <p className="mt-1 text-sm text-slate-600">Banche del Tempo – Comune di Poggioreale</p>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="alert-info">
            Per garantire equilibrio negli scambi, non è consentito scendere oltre le <span className="font-semibold">-3 ore</span> di saldo.
          </div>

          <div className="mt-4 space-y-3">
            <details className="group rounded-2xl border border-slate-200 bg-white/70" open>
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <HandshakeIcon fontSize="small" />
                  1. Principio
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                La Banca del Tempo è uno strumento di scambio in cui l’unità di valore è l’ora. Gli utenti mettono a disposizione abilità e tempo,
                ricevendo in cambio tempo da altri utenti, in un’ottica di reciprocità e collaborazione.
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <PersonIcon fontSize="small" />
                  2. Accesso e profilo
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>La registrazione deve essere approvata prima di poter utilizzare i servizi.</li>
                  <li>Le credenziali sono personali e non devono essere condivise.</li>
                  <li>Ogni utente è responsabile dell’accuratezza dei propri dati e delle informazioni inserite nel profilo.</li>
                  <li>Nel profilo è possibile gestire le proprie abilità (categorie e sottocategorie) e le eventuali note descrittive.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <VerifiedUserIcon fontSize="small" />
                  3. Abilità e disponibilità
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>Le abilità pubblicate devono descrivere servizi realmente offerti e coerenti con le categorie disponibili.</li>
                  <li>È vietato inserire contenuti offensivi, discriminatori o non pertinenti.</li>
                  <li>È responsabilità dell’utente concordare con l’altra parte tempi, modalità e luogo dello scambio.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <SwapHorizIcon fontSize="small" />
                  4. Richiesta di scambio
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>
                    Prima di effettuare uno scambio, è necessario inviare una <span className="font-semibold">richiesta di scambio</span> all’utente
                    con cui si desidera collaborare. Il pulsante <span className="font-semibold">"Proponi scambio"</span> è disponibile nella
                    sezione <span className="font-semibold">Utenti e abilità</span>.
                  </li>
                  <li>La richiesta deve includere una descrizione chiara dell’attività che si intende proporre o ricevere.</li>
                  <li>
                    È possibile consultare in qualsiasi momento le richieste inviate e ricevute nella sezione{" "}
                    <span className="font-semibold">Le mie richieste</span>.
                  </li>
                  <li>
                    Solo dopo che entrambe le parti si sono accordate, lo scambio effettivo va registrato tramite{" "}
                    <span className="font-semibold">Registra scambio</span> per aggiornare i saldi.
                  </li>
                  <li>Le richieste possono essere disattivate dall’amministrazione qualora risultino non conformi al regolamento.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <AccessTimeIcon fontSize="small" />
                  5. Scambi di tempo
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>Uno scambio deve essere inserito indicando categoria, eventuale sottocategoria, descrizione e ore.</li>
                  <li>Le ore inserite devono corrispondere al tempo effettivamente scambiato e concordato tra le parti.</li>
                  <li>Gli scambi possono essere soggetti a verifica e approvazione secondo le regole della piattaforma.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <AccountBalanceWalletIcon fontSize="small" />
                  6. Saldo ore
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>Il saldo rappresenta ore a credito o a debito dell’utente.</li>
                  <li>
                    Non è consentito scendere oltre le <span className="font-semibold">-3 ore</span> di saldo.
                  </li>
                  <li>L’uso corretto del sistema richiede equilibrio e reciprocità: gli utenti sono invitati a mantenere un saldo sostenibile.</li>
                  <li>In caso di anomalie o contestazioni, l’amministrazione può intervenire per verifiche e correzioni.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <GavelIcon fontSize="small" />
                  7. Comportamento e responsabilità
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>È richiesto un comportamento rispettoso, collaborativo e conforme alle norme di convivenza civile.</li>
                  <li>È vietato utilizzare la piattaforma per attività illecite o che possano arrecare danno a terzi.</li>
                  <li>Eventuali accordi specifici tra utenti restano sotto la responsabilità delle parti coinvolte.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <SettingsIcon fontSize="small" />
                  8. Gestione e interventi
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                <ul className="list-disc space-y-2 pl-5">
                  <li>L’amministrazione può moderare contenuti, gestire utenti e intervenire sugli scambi in caso di necessità.</li>
                  <li>In caso di violazioni del regolamento possono essere adottate misure fino alla sospensione o disattivazione dell’account.</li>
                </ul>
              </div>
            </details>

            <details className="group rounded-2xl border border-slate-200 bg-white/70">
              <summary className="flex cursor-pointer items-center justify-between gap-3 px-4 py-4">
                <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
                  <EmailIcon fontSize="small" />
                  9. Comunicazioni
                </div>
                <ExpandMoreIcon fontSize="small" className="transition group-open:rotate-180" />
              </summary>
              <div className="px-4 pb-4 text-sm text-slate-700">
                Alcune operazioni possono generare comunicazioni automatiche via email (ad esempio notifiche operative o variazioni rilevanti del profilo). È
                responsabilità dell’utente mantenere un indirizzo email valido e consultarlo periodicamente.
              </div>
            </details>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regolamento;
